import { createRouter, createWebHistory } from 'vue-router';
import RecommendationWizard from "./RecommendationWizardPage.vue";


const router = createRouter({
  history: createWebHistory(),
  routes: []
});

bootVue('.recommendation-wizard-app', RecommendationWizard, {
  jsonProps: ['questions', 'preselectedAnswers'],
  beforeMount: (el, props) => {},
  createAppWrapper: (wrapped, props) => {
    const app = createApp(wrapped, props);
    app.use(router);
    return app;
  }
});